import { useContext } from "react";
import { GlobalContext } from "../context/Globalstate";


export default function Balance() {
  const { transactions } = useContext(GlobalContext);

  const amounts = transactions.map((transaction) => transaction.amount);

  const total = amounts.reduce((acc, item) => (acc += item), 0).toFixed(2);

  return (
    <>
      <h4>YOUR BALANCE</h4>
      <h1 id="Balance"> NGN{total}</h1>
    </>
  );
}
